import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center p-1">
                <img 
                  src="https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/AfD+BW+Logo+blau-1920w.jpg"
                  alt="AfD Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-2xl font-bold">AfD Bad Windsheim</h3>
            </div>
            <p className="text-primary-200 leading-relaxed mb-6">
              Wir setzen uns für Bürgernähe, Transparenz und eine lebenswerte Stadt Bad Windsheim ein. Gemeinsam für eine starke Zukunft.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/p/AfD-Ortsverband-Bad-Windsheim-61574808512040/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-primary-800 hover:bg-secondary-600 rounded-lg flex items-center justify-center transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/afd_ov_bw/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-primary-800 hover:bg-secondary-600 rounded-lg flex items-center justify-center transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Schnellzugriff</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/kandidaten" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Kandidaten
                </Link>
              </li>
              <li>
                <Link to="/programm" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Programm
                </Link>
              </li>
              <li>
                <Link to="/stadtratswahl" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Stadtratswahl
                </Link>
              </li>
              <li>
                <Link to="/kreistagswahl" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Kreistagswahl
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/links" className="text-primary-200 hover:text-white transition-colors duration-300 cursor-pointer">
                  Weiterführende Links
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Kontakt</h4>
            <ul className="space-y-3 text-primary-200">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-secondary-500 mt-1"></i>
                <span>0155 - 688 44 604</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-secondary-500 mt-1"></i>
                <a href="mailto:benno.bulitta@web.de" className="hover:text-white transition-colors duration-300">
                  benno.bulitta@web.de
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-secondary-500 mt-1"></i>
                <span>
                  Augustinumstraße 4<br />
                  91438 Bad Windsheim
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-primary-300 text-sm">
              © {new Date().getFullYear()} AfD Bad Windsheim. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/impressum" className="text-primary-300 hover:text-white transition-colors duration-300 cursor-pointer">
                Impressum
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
